import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiClientService } from "../../../common/services/api-client.service";
import { IRebusMessage } from "./rebus-messages/rebus-messages.component";
import { RebusQueueDTO } from "./rebus.models";

@Injectable({
    providedIn: "root"
})
export class RebusService {
    queues$: BehaviorSubject<RebusQueueDTO[]>;

    private readonly apiClient = inject(ApiClientService);

    constructor() {
        this.queues$ = new BehaviorSubject<RebusQueueDTO[]>([]);
    }

    delete(type: string, queue: string, ids: string[], subQueue: string = null): Observable<void> {
        const queuePath = this.generateSubQueuePath(queue, subQueue);
        return this.apiClient.post<any, any>(`maintenance/rebus/queues/${type}/${queuePath}/messages/delete`, ids, false).pipe();
    }

    getMessages(type: string, adress: string, subQueue: string = null): Observable<IRebusMessage[]> {
        const queuePath = this.generateSubQueuePath(adress, subQueue);
        return this.apiClient.get<IRebusMessage[]>(`maintenance/rebus/queues/${type}/${queuePath}`, false);
    }

    getQueues(): Observable<RebusQueueDTO[]> {
        return this.apiClient.get<RebusQueueDTO[]>("maintenance/rebus/queues", false);
    }

    purgeQueue(type: string, queue: string, subQueue: string = null): Observable<void> {
        const queuePath = this.generateSubQueuePath(queue, subQueue);
        return this.apiClient.post<any, any>(`maintenance/rebus/queues/${type}/${queuePath}/purge`, null, false).pipe();
    }

    reRun(type: string, queue: string, subQueue: string, ids: string[]): Observable<void> {
        const queuePath = this.generateSubQueuePath(queue, subQueue);
        return this.apiClient.post<any, any>(`maintenance/rebus/queues/${type}/${queuePath}/messages/rerun`, ids, false).pipe();
    }

    private generateSubQueuePath(queue: string, subQueue: string) {
        if (subQueue) {
            return `${queue}/${subQueue}`;
        }
        return `${queue}`;
    }
}
